module.exports = __webpack_public_path__ + "img/solution_e.85ebc412.png";